import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, money } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Field, AccountSelect } from "@/components/FormBits";
import TxTable from "@/components/TxTable";

const PAYEES = ["Electric Company", "Water Utility", "Internet Provider", "Mobile Phone", "Auto Insurance", "Mortgage"];

export default function BillPay() {
  const [accounts, setAccounts] = useState([]);
  const [f, setF] = useState({ from_account_id: "", payee: "", amount: "", memo: "" });
  const [k, setK] = useState(0);
  const load = () => api.get("/dashboard").then((r) => setAccounts(r.data.accounts.filter((a) => a.type !== "investment")));
  useEffect(() => { load(); }, []);
  const set = (key) => (v) => setF((p) => ({ ...p, [key]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!f.from_account_id) return toast.error("Choose an account");
    try {
      await api.post("/billpay", { ...f, amount: parseFloat(f.amount) });
      toast.success(`Paid ${money(parseFloat(f.amount))} to ${f.payee}`);
      setF((p) => ({ ...p, payee: "", amount: "", memo: "" })); setK(k + 1); load();
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div data-testid="billpay-page">
      <h1 className="text-4xl sm:text-5xl font-extrabold text-[var(--navy)] mb-2">Bill Pay</h1>
      <p className="text-slate-500 mb-8">Pay your bills from checking in a few clicks.</p>
      <div className="grid lg:grid-cols-[1fr_1.3fr] gap-8">
        <form onSubmit={submit} className="tile h-fit" data-testid="billpay-form">
          <div className="p-7 grid gap-5">
            <Field label="Pay from"><AccountSelect accounts={accounts} value={f.from_account_id} onChange={set("from_account_id")} testid="billpay-from-select" /></Field>
            <Field label="Payee"><Input value={f.payee} onChange={(e) => set("payee")(e.target.value)} required data-testid="billpay-payee-input" /></Field>
            <div className="flex flex-wrap gap-2">
              {PAYEES.map((p) => <button type="button" key={p} onClick={() => set("payee")(p)} className="text-xs border rounded-full px-3 py-1 hover:border-[var(--blue)] hover:text-[var(--blue)]" data-testid={`payee-chip-${p.toLowerCase().replace(/\s+/g, "-")}`}>{p}</button>)}
            </div>
            <Field label="Amount"><Input type="number" step="0.01" min="0.01" value={f.amount} onChange={(e) => set("amount")(e.target.value)} required data-testid="billpay-amount-input" /></Field>
            <Field label="Memo / account number (optional)"><Input value={f.memo} onChange={(e) => set("memo")(e.target.value)} data-testid="billpay-memo-input" /></Field>
            <Button className="rounded-full bg-[var(--blue)] hover:bg-[var(--navy)] h-11" data-testid="billpay-submit-button">Pay bill</Button>
          </div>
        </form>
        <div>
          <h2 className="text-lg font-bold text-[var(--navy)] mb-4">Recent activity</h2>
          <TxTable refreshKey={k} fixedType="billpay" />
        </div>
      </div>
    </div>
  );
}
